"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_URL_BASE_V2 = exports.API_MARKET_URL = exports.API_URL_AUTH_TOKEN = exports.API_URL_BASE = void 0;
exports.API_URL_BASE = 'https://kmnk2k677k.execute-api.us-west-2.amazonaws.com';
exports.API_URL_AUTH_TOKEN = 'https://819fet6r4d.execute-api.us-west-2.amazonaws.com';
exports.API_MARKET_URL = 'https://kmnk2k677k.execute-api.us-west-2.amazonaws.com/qa/market-place';
exports.API_URL_BASE_V2 = 'https://q80i0bir9k.execute-api.us-east-1.amazonaws.com';
